import React, { useEffect, useRef, useState } from "react";
import cx from "classnames";
import MissingImage from "@/public/images/image-missing.png";

export default function Image({
  src,
  alt,
  role,
  onError,
  onClick,
  customClass,
  forwardRef,
  crop,
}) {
  const [dimensions, setDimensions] = useState({ width: "", height: "" });
  const elem = useRef();

  const handleError = (e) => {
    e.target.src = MissingImage.src;
    onError && onError(e, src);
  };

  useEffect(() => {
    if (elem.current) {
      const styles = window.getComputedStyle(elem.current);
      const formatValue = (value) => Math.floor(value.split("p")[0]);
      setDimensions({
        width: formatValue(styles.width),
        height: formatValue(styles.height),
      });
    }
  }, []);

  return (
    <img
      src={
        crop ? `${src}?wid=${dimensions.width}&hei=${dimensions.height}` : src
      }
      alt={alt}
      role={role}
      onError={(e) => handleError(e)}
      onClick={(e) => onClick && onClick(e)}
      className={cx("image", customClass ?? null)}
      ref={forwardRef ?? elem}
    />
  );
}
